export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11153.e54f160b.jpg";